var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasOrganizer)?_c('div',[_c('ListItemAccount',_vm._b({key:_vm.listItemBind.name,class:_vm.putClass ? 'tournament-mini-card_organizer' : null,attrs:{"size":_vm.size}},'ListItemAccount',_vm.listItemBind,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }